import { render, staticRenderFns } from "./ProfileSuggestedSurgeons.vue?vue&type=template&id=d3dc03ce"
import script from "./ProfileSuggestedSurgeons.vue?vue&type=script&lang=js"
export * from "./ProfileSuggestedSurgeons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports